import React from 'react';
import { useEffect, useState } from 'react';
import Card3 from './card3/card';
import Loading from '../../../lib/component/loading1/loading';
import classifyApi from '../js/classifyApi';
import { CategoryItem } from '../js/interface';
import statisticsApi from '../../../lib/statisticsApi';

export default () => {
  const [boy, setBoy] = useState<CategoryItem[]>([]);
  const [girl, setGirl] = useState<CategoryItem[]>([]);
  const [list, setList] = useState<CategoryItem[]>([]);
  useEffect(() => {
    classifyApi.getHomeApi(
      (res: any) => {
        setBoy(res.category_boy);
        setGirl(res.category_girl);
        setList(res.category_list);
      },
      () => {}
    );
    statisticsApi.statisticsApi(5);
  }, []);

  function listRender() {
    if (list.length) {
      return <Card3 {...{ title: '图书分类', arr: list }}></Card3>;
    } else {
      return <Loading></Loading>;
    }
  }

  function boyRender() {
    if (boy.length) {
      return <Card3 {...{ title: '男频原创', arr: boy }}></Card3>;
    } else {
      return <Loading></Loading>;
    }
  }

  function girlRender() {
    if (girl.length) {
      return <Card3 {...{ title: '女频原创', arr: girl }}></Card3>;
    } else {
      return <Loading></Loading>;
    }
  }

  return (
    <>
      {listRender()}
      {boyRender()}
      {girlRender()}
      <div style={{ height: '50px' }}></div>
    </>
  );
};
